

















































import {Component, Vue} from 'vue-property-decorator';
import {
  Getter,
} from 'vuex-class';

@Component
export default class GuestToolbar extends Vue {
  @Getter('guest/auth/isAdmin') private isAdmin!: any;

  private links: any = [
    {hash: '#welcome', text: ('guest.home')},
    {route: 'GuestAnimals', text: ('guest.animals')},
  ];

  private toggleDrawer() {
    this.sidebar = !this.sidebar;
  }

  private goToElement(element) {
    if (element.route) {
      this.$router.push({name: element.route});
    } else if (this.$router.currentRoute.name === 'GuestHome' && element.hash) {
      this.$vuetify.goTo(element.hash);
    } else {
      this.$router.push({name: 'GuestHome', hash: element.hash});
    }
  }

  private get sidebar() {
    return this.$store.getters['common/ui/sidebar'];
  }

  private set sidebar(value) {
    this.$store.dispatch('common/ui/setSidebar', value);
  }
}
